import React, { FC, ReactElement } from "react";
import {
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";
import "./Footer.scss";

const Footer: FC = (): ReactElement => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="fk-footer">

      {/* ── Top 4-column grid ── */}
      <div className="fk-top">

        {/* 1. Brand + Contact */}
        <div className="fk-col">
          <p className="fk-col-title">About</p>
          <h4 className="fk-brand-name">
            <span className="fk-drop">◆</span> Finllie Water
          </h4>
          <p className="fk-brand-tag">Pure water. Delivered with care.</p>

          <div className="fk-contact-row">
            <span className="fk-icon">☎</span>
            <span>Call us: <strong>+91 99000 97422</strong></span>
          </div>
          <div className="fk-contact-row">
            <span className="fk-icon">✉</span>
            <span>Email: <strong>finlliesales@gmail.com</strong></span>
          </div>
          <span className="fk-badge">● Open as per Business Hours</span>
        </div>

        {/* 2. Quick Links */}
        <div className="fk-col">
          <p className="fk-col-title">Quick Links</p>
          <ul className="fk-links">
            <li><a href="/terms">Terms &amp; Conditions</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/refund-policy">Refund &amp; Returns</a></li>
            <li><a href="/shipping-policy">Shipping Info</a></li>
            <li><a href="/contact-us">Contact Us</a></li>
          </ul>
        </div>

        {/* 3. Business Hours */}
        <div className="fk-col">
          <p className="fk-col-title">Business Hours</p>
          <ul className="fk-hours">
            <li>
              <span className="fk-day">Mon – Fri</span>
              <span className="fk-time">9AM – 5PM</span>
            </li>
            <li>
              <span className="fk-day">Saturday</span>
              <span className="fk-time">10AM – 4PM</span>
            </li>
            <li>
              <span className="fk-day">Sunday</span>
              <span className="fk-time closed">Closed</span>
            </li>
          </ul>
        </div>

        {/* 4. Follow Us */}
        <div className="fk-col">
          <p className="fk-col-title">Follow Us</p>
          <div className="fk-social-list">
            <a
              className="fk-social-btn"
              href="https://www.instagram.com/finlliewaterofficial/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramOutlined /> Instagram
            </a>
            <a
              className="fk-social-btn"
              href="https://www.facebook.com/people/finlliewaterofficial/61583777931027/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookOutlined /> Facebook
            </a>
            <a
              className="fk-social-btn"
              href="#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YoutubeOutlined /> YouTube
            </a>
          </div>
        </div>

      </div>

      {/* ── Policy strip ── */}
      <div className="fk-mid">
        <div className="fk-policy-links">
          <a href="/terms">Terms</a><span className="fk-pipe">|</span>
          <a href="/privacy">Privacy</a><span className="fk-pipe">|</span>
          <a href="/refund-policy">Refund Policy</a><span className="fk-pipe">|</span>
          <a href="/shipping-policy">Shipping</a><span className="fk-pipe">|</span>
          <a href="/contact-us">Contact</a>
        </div>
        <span className="fk-cert">GSTIN &amp; FSSAI Certified</span>
      </div>

      {/* ── Bottom copyright ── */}
      <div className="fk-bottom">
        <span className="fk-copy">
          &copy; {currentYear} <strong>Finllie Water Plant</strong>. All rights reserved.
        </span>
        <span className="fk-credit">
          Crafted by{" "}
          <a
            href="https://www.linkedin.com/company/jpg-ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            JpgTech
          </a>
        </span>
      </div>

    </footer>
  );
};

export default Footer;